import React from 'react'

import PropTypes from 'prop-types'

import IconAngleRight from '@adv-mt/mt-svg-icons/lib/ChevronRight.js'
import IconTimer from '@adv-mt/mt-svg-icons/lib/Timer.js'

const NavigationLastAdsSearchesLink = ({title, url, className}) => (
  <a href={url} className={`${className}-link`}>
    <IconTimer svgClass={`${className}-linkTimer`} />
    <span className={`${className}-linkText`}>{title}</span>
    <IconAngleRight svgClass={`${className}-linkChev`} />
  </a>
)

NavigationLastAdsSearchesLink.displayName = 'NavigationLastAdsSearchesLink'
NavigationLastAdsSearchesLink.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  className: PropTypes.string
}

export default React.memo(NavigationLastAdsSearchesLink)
